import { getValueOrDefault } from '../../../helpers/getvalueOrDefault';
import type { ChartResponse } from '../../../redux/config/chart-data';

export function transformBiDimensionalLineChart(data: Array<ChartResponse>) {
  return data?.map((item: ChartResponse) => {
    return {
      field: getValueOrDefault(item.field, '[none]'),
      value: Number(item.value),
    };
  });
}
